import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { TxDefs } from '../../../services/Ebootis.Queries/TxDefs';
import { TxDefSelectService } from './tx-def-select.service';

@Component({
	selector: 'app-tx-def-select',
	templateUrl: './tx-def-select.component.html',
	styleUrls: ['./tx-def-select.component.scss']
})
export class TxDefSelectComponent {

	@Input() public txDefControl: UntypedFormControl;
	@Input() set configOid(p_configOid: string) {
		this.m_txDefs$ = this.m_txDefService.getTxDefs(p_configOid);
	}
	@Input() public disabled: boolean = false;
	@Input() public readonly: boolean = false;

	@Output() public txDefSelected: EventEmitter<string> = new EventEmitter();

	public m_txDefs$: Observable<TxDefs.Result[]>;

	constructor(
		private m_txDefService: TxDefSelectService
	) { }

	/**
	 * Bei einer Änderung der Vorgangsart wird der Inhalt des Controls an das aufrufende Component übergeben.
	 * @param event ChangeEvent
	 */
	public changedTxDef(event): void {
		this.txDefSelected.emit(this.txDefControl.value);
	}

	/**
	 * Prüft ob das aktuelle FormControl ein Pflichtfeld ist.
	 */
	public isRequiredField(): boolean {

		if (!this.txDefControl.validator) {
			return false;
		}

		const validator = this.txDefControl.validator({} as AbstractControl);
		return (validator && validator.required);
	}

}
